import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/pro-regular-svg-icons/faFileLines';

import React from 'react';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import style from '../../onboard-cards.module.less';
import { messages } from '../../messages';

export const ManualOrderHeaderImage = () => {
  return (
    <FlexRow className={style['manual-order-header']}>
      <FontAwesomeIcon className={style['provider-icon']} icon={faFileLines} />
      <Text textType={TextType.H4} value={messages.manualOrder} />
    </FlexRow>
  );
};
